import { useQuery } from '@tanstack/react-query';
import { api, GrSubscriptionResponse } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

interface UseSubscriptionReturn {
  subscription: GrSubscriptionResponse | null;
  loading: boolean;
  error: string | null;
  refresh: () => void;
}

export function useSubscription(): UseSubscriptionReturn {
  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: queryKeys.gameRewards.subscription(),
    queryFn: () => api.getGameRewardsSubscription(),
  });

  return {
    subscription: data?.subscription ?? null,
    loading: isLoading,
    error: error instanceof Error ? error.message : isError ? 'Failed to load subscription' : null,
    refresh: () => {
      refetch();
    },
  };
}
